"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialLinks = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const list_item_styles_1 = require("@/components/common/list-item/list-item.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
require("@/components/common/avatar/avatar");
require("@/components/common/icon/icon");
require("@/components/common/list-item/list-item");
const PLATFORMS = [
    { key: 'github', label: 'Github', icon: icon_names_1.ICON_NAMES.GITHUB },
    { key: 'pinterest', label: 'Pinterest', icon: icon_names_1.ICON_NAMES.PINTEREST },
    { key: 'facebook', label: 'Facebook', icon: icon_names_1.ICON_NAMES.FACEBOOK },
    { key: 'notion', label: 'Notion', icon: icon_names_1.ICON_NAMES.NOTION },
];
let SocialLinks = class SocialLinks extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.github = '';
        this.pinterest = '';
        this.facebook = '';
        this.notion = '';
        this.compact = false;
    }
    render() {
        if (!this.activeLinks.length)
            return lit_1.nothing;
        return this.compact ? this.renderCompact() : this.renderDefault();
    }
    get activeLinks() {
        return PLATFORMS.flatMap(({ key, label, icon }) => {
            const href = this[key];
            if (!href)
                return [];
            return [{ key, label, icon, href }];
        });
    }
    renderDefault() {
        return (0, lit_1.html) `
      <div role="list">${this.renderDefaultLinks()}</div>
    `;
    }
    renderCompact() {
        return (0, lit_1.html) `
      <div class="compact">${this.renderCompactLinks()}</div>
    `;
    }
    renderDefaultLinks() {
        return this.activeLinks.map(link => this.renderDefaultLink(link));
    }
    renderDefaultLink({ label, icon, href }) {
        return (0, lit_1.html) `
      <div role="listitem">
        <a href=${href} target="_blank" rel="noopener noreferrer">
          <mm-list-item label=${label} icon=${icon}>
            <mm-icon slot="trailing" name=${icon_names_1.ICON_NAMES.SHARE} size="small"></mm-icon>
          </mm-list-item>
        </a>
      </div>
    `;
    }
    renderCompactLinks() {
        return this.activeLinks.map(link => this.renderCompactLink(link));
    }
    renderCompactLink({ label, icon, href }) {
        return (0, lit_1.html) `
      <a href=${href} target="_blank" rel="noopener noreferrer" aria-label=${label}>
        <mm-avatar variant="primary" size="32" icon=${icon}></mm-avatar>
      </a>
    `;
    }
};
SocialLinks.styles = [
    shared_styles_1.resetStyles,
    list_item_styles_1.interactiveRowStyles,
    (0, lit_1.css) `
      .compact {
        display: flex;
        gap: var(--space-2);
      }

      /* compact은 행이 아니라 아바타를 늘어놓은 묶음이라 행 스킨의 폭 규칙을 따르지 않는다 */
      .compact a {
        width: auto;
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SocialLinks.prototype, "github", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SocialLinks.prototype, "pinterest", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SocialLinks.prototype, "facebook", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SocialLinks.prototype, "notion", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], SocialLinks.prototype, "compact", void 0);
SocialLinks = __decorate([
    (0, decorators_js_1.customElement)('mm-social-links')
], SocialLinks);
exports.SocialLinks = SocialLinks;
//# sourceMappingURL=data:application/json;base64,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